import React,{useEffect} from 'react';
import useStyles from './Styles';
import Paper from '@mui/material/Paper';
import Title from './Title';

const Law = ()=> {
    const classes = useStyles();
    useEffect(()=>{
        window.scrollTo(0,0);
    },[])    
    return (
        <div id="law" className={classes.root+" "+classes.policy}>
            <Paper className={classes.paper}>
                <Title text="特定商取引に関する法律に基づく表示" icon="assignment"/>
                <dl className="document">
                    <dt>1．販売業者</dt>
                    <dd>有限会社レトロインク</dd>
                    <dt>2．販売責任者氏名</dt>
                    <dd>石村寛之</dd>
                    <dt>3．所在地と連絡先</dt>
                    <dd>
                        〒181-0001 東京都三鷹市井の頭4-26-7<br/>
                        TEL 0422-24-9529（店舗）　0422-49-2903（会社）<br/>
                        Email store@retro-biz.com<br/>
                    </dd>
                    <dt>4．商品代金以外の必要料金</dt>
                    <dd>
                        <ol>
                            <li>消費税（ただし、表示価格は全て税込）</li>
                            <li>送料<br />
                            ・ゆうパケット等…　210円<br />
                            ・ゆうパック…　750円<br/>
                            ※配送方法は購入者が選択。ただし一部商品でゆうパケット等不可。<br/>
                            ※商品代金の合計が2,800円以上の場合、ゆうパケット等の送料無料。<br/>
                            ※商品代金の合計が10,000円以上の場合、ゆうパックの送料無料。</li>
                            <li>支払手数料<br/>
                            ・銀行振込（先払い）…　金融機関の窓口やATMで購入者が負担<br/>
                            ・コンビニ決済（先払い）…　130円<br/>
                            ・PayPal（先払い）…　無料<br/>
                            ・代金引換…　360円<br/>
                            ※支払方法は購入者が選択。<br/>
                            ※商品代金の合計が3,500円以上の場合、コンビニ決済の支払手数料無料。<br/>
                            ※一部の商品で、支払手数料が無料になるサービスあり。</li>
                        </ol>
                    </dd>
                    <dt>5．申込の有効期限</dt>
                    <dd>在庫時は随時有効。在庫切れはメールで連絡。</dd>
                    <dt>6．不良品</dt>
                    <dd>商品到着後７日以内に限り、返品もしくは良品と交換。</dd>
                    <dt>7．引き渡し時期</dt>
                    <dd>在庫がある商品については注文の翌営業日までに発送。<br />在庫切れの商品や、受注生産の商品の場合は、納品予定日が確定し次第にメールで連絡。</dd>
                    <dt id="p8">8．お支払い方法</dt>
                    <dd>
                        ・銀行振込（ゆうちょ銀行）<br/>
                        ・PayPal<br/>
                        ・コンビニ決済<br/>
                        ・代金引換<br/>
                        本サイトからリンクする他サイト（作家さんのブログなど）は決済の対象外。<br/>
                    </dd>
                    <dt>9．お支払い期限</dt>
                    <dd>お支払方法の選択後１０日以内</dd>
                    <dt>10．返品期限</dt>
                    <dd>商品到着より７日以内</dd>
                    <dt>11．返品送料</dt>
                    <dd>お客様都合の場合はお客様負担、不良品交換・誤品配送交換は当社負担</dd>
                </dl>
            </Paper>
        </div>
    )
}

export default Law;